import React from "react";
import "./filesTable.scss";
import Checkbox from "../checkboxes/checkbox/Checkbox";
import compareIcon from "../../images/files-page/comapare-icon.svg";
import viewIcon from "../../images/files-page/table-icons/eye-icon.svg";
import downloadIcon from "../../images/files-page/table-icons/download-icon.svg";
import copyIcon from "../../images/files-page/table-icons/copy-icon.svg";
import compareTableIcon from "../../images/files-page/table-icons/compare-icon.svg";
import editIcon from "../../images/files-page/table-icons/pen-icon.svg";
import deleteIcon from "../../images/files-page/table-icons/delete-icon.svg";
import moment from "moment";
import { useNavigate } from "react-router-dom";

const FilesTable = ({ setShowFrameStructureModal, files, checkboxIsPublickHandler, setWatchingIframeId }) => {
    const navigate = useNavigate();

    const setWatchingIFrameHandler = (id) => {
        setWatchingIframeId(id);
        setShowFrameStructureModal(true);
    };
    return (
        <table className="table table-content-top">
            <thead>
                <tr>
                    <th>Элемент оформления</th>
                    <th>Відділ</th>
                    <th>Обладнання</th>
                    <th>Дата створення</th>
                    <th>Версія</th>
                    <th>Автор</th>
                    <th>
                        {/* <div className="table__compare">
                            <div className="table__compare-title">Прівняти</div>
                            <div className="table__compare-button">
                                <img src={compareIcon} alt="compare" />
                                <div className="table__compare-button-counter">2</div>
                            </div>
                        </div> */}
                    </th>
                </tr>
            </thead>
            <tbody>
                {files?.data?.map((file) => {
                    return (
                        <tr className="row" key={file.id}>
                            <td>{file.design.title}</td>
                            <td className="middle-element">{file.department.title}</td>
                            <td className="middle-element">{file.equipment.title}</td>
                            <td className="middle-element"> {moment(file.created_at).format("DD.MM.YYYY")}</td>
                            <td className="middle-element">№ {file.version}</td>
                            <td className="middle-element">{file.user.name}</td>
                            <td>
                                <div className="table__settings">
                                    <div className="table__settings-functions">
                                        <div
                                            className="table__settings-functions-green-icon"
                                            onClick={() => setWatchingIFrameHandler(file.id)}
                                        >
                                            <img src={viewIcon} alt="view" />
                                        </div>
                                        <div className="table__settings-functions-green-icon">
                                            <img src={downloadIcon} alt="download" />
                                        </div>
                                        {/* <div className="table__settings-functions-green-icon">
                                    <img src={copyIcon} alt="copy" />
                                </div> */}
                                        <div className="table__settings-functions-green-icon">
                                            <img src={compareTableIcon} alt="compare" />
                                        </div>
                                        <div
                                            className="table__settings-functions-green-icon"
                                            onClick={() => navigate("/files/edit/" + file.id)}
                                        >
                                            <img src={editIcon} alt="edit" />
                                        </div>
                                        {/* <div className="table__settings-functions-red-icon">
                                    <img src={deleteIcon} alt="delete" />
                                </div> */}
                                    </div>
                                    <div className="table__settings-checkbox">
                                        <Checkbox
                                            onClick={() => checkboxIsPublickHandler(file.id, file.is_public)}
                                            checked={file.is_public}
                                        />
                                        <div className="table__settings-checkbox-lable">Публічна версія</div>
                                    </div>
                                </div>
                            </td>
                        </tr>
                    );
                })}
            </tbody>
        </table>
    );
};

export default FilesTable;
